import { Inject, Injectable, InjectionToken, Optional } from '@angular/core';
import {
  HttpInterceptor,
  HttpEvent,
  HttpHandler,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';

import { LoaderService } from './loader.service';
import { withLoader } from './with-loader';

export const LOADER_URLS = new InjectionToken<string[]>('LOADER_URLS');
export const EXCLUDE_URLS = new InjectionToken<string[]>('EXCLUDE_URLS');

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
  constructor(
    private _loader: LoaderService,
    @Optional() @Inject(LOADER_URLS) private _loaderUrls?: string[],
    @Optional() @Inject(EXCLUDE_URLS) private _excludeUrls?: string[]
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (
      !this._loaderUrls?.length ||
      this._urlIsExcluded(req.url) ||
      !this._urlIsIncluded(req.url)
    ) {
      return next.handle(req);
    }

    return next.handle(req).pipe(withLoader(this._loader));
  }

  private _urlIsIncluded(url: string): boolean {
    return this._urlMatchesList(url, this._loaderUrls);
  }

  private _urlIsExcluded(url: string): boolean {
    return this._urlMatchesList(url, this._excludeUrls);
  }

  private _urlMatchesList(url: string, list: string[] = []): boolean {
    return list.some((listUrl) => new RegExp(listUrl).test(url));
  }
}
